import { render } from "./health_safety_environment.html?vue&type=template&id=57cc54ab&external"
import script from "./health_safety_environment.js?vue&type=script&lang=js&external"
export * from "./health_safety_environment.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__